// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import axios from 'axios'
import VueProgressBar from 'vue-progressbar'
import Toasted from 'vue-toasted'
import Ripple from 'vue-ripple-directive'

import App from './App'
import router from './router'
import store from './store'

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

/**
 * axios 설정
 */
axios.defaults.baseURL = window.location.origin
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.withCredentials = true

axios.interceptors.request.use(request => {
  console.log({request})
  app.$Progress.start()
  return request
}, (error) => {
  console.log({error})
  app.$Progress.fail()
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  console.log({response})
  app.$Progress.finish()
  return response
}, (error) => {
  console.error({error})
  app.$Progress.fail()
  if (error.response && error.response.status === 401) {
    router.push('/pages/login?returnPath=site')
    return Promise.reject(error)
  } else {
    return Promise.reject(error)
  }
})

Vue.prototype.$http = axios

/**
 * vue-progressbar 설정
 */
Vue.use(VueProgressBar, {
  color: '#0000ff',
  failedColor: '#f86c6b',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})

/**
 * vue-toasted 설정
 */
Vue.use(Toasted, {
  position: 'top-center',
  theme: 'outline',
  iconPack: 'fontawesome'
})
Vue.toasted.register('info', message => message, {
  duration: 3000,
  type: 'info',
  icon: 'info-circle'
})
Vue.toasted.register('success', message => message, {
  duration: 3000,
  type: 'success',
  icon: 'check-circle'
})
Vue.toasted.register('error', message => message, {
  duration: 3000,
  type: 'error',
  icon: 'exclamation-circle'
})

/**
 * vue-ripple-directive 설정
 */
Ripple.color = 'rgba(255, 255, 255, 0.35)'
Ripple.zIndex = 55
Vue.directive('ripple', Ripple)

function _formatErrorMessage (error) {
  if (error && error.response) {
    console.log(error.response)
  } else {
    console.log(error)
  }
  let message
  if (error &&
    error.response &&
    error.response.data &&
    error.response.data.error &&
    error.response.data.error.message) {
    message = error.response.data.error.message
  }
  if (message === undefined) {
    message = '시스템 오류가 발생하였습니다.'
    if (error && error.message) {
      message += '\n' + error.message
    }
  }
  console.log('message=>' + message)
  return message
}

Vue.mixin({
  methods: {
    // 에러메시지 포맷
    formatErrorMessage: (error) => {
      return _formatErrorMessage(error)
    }
  }
})

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js